export enum SuggestionOriginEnum {
  MONOPOLIO = 'wiggot',
  GOOGLE = 'google'
}
